export const SERVICES_HEADER_FIELDS = [
  'client',
  'elevator',
  'address',
  'elevatorId',
  'project',
  'period',
  'type',
  'check44Text',
  'check45Text',
  'check46Text',
  'check47Text',
];
